module.exports = __webpack_public_path__ + "assets1752042029796/img/avator.bd584bb1.png";